import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, Secretary } from '@/auth/AuthContext';
import { Building2, ArrowRight, LogOut } from 'lucide-react';

export default function SecretarySelectorPage() {
    const { user, setActiveSecretary, logout } = useAuth();
    const [teamId, setTeamId] = useState('');
    const navigate = useNavigate();
    const teams = user?.itTeams ?? [];
    const team = teams.find(t => t.id === teamId) ?? (teams.length === 1 ? teams[0] : undefined);
    const select = (secretary: Secretary) => {
        setActiveSecretary(secretary);
        navigate(user?.role==='VIEWER'?'/reports':'/dashboard');
    };
    return <div className="auth-shell secretary-selector flex-col">
        <div className="w-full max-w-2xl">
            <h1 className="app-page-title text-3xl mb-3">Equipe de TI</h1>
            <p className="text-slate-400 mb-6">Selecione a equipe de trabalho e a secretaria atendida. O estoque é compartilhado somente entre as secretarias da mesma equipe.</p>
            {!teams.length && <p className="feedback-error">Nenhuma equipe vinculada. Solicite o vínculo ao administrador.</p>}
            <div className="grid gap-3 md:grid-cols-2 mb-6">
                {teams.map(t => <button key={t.id} onClick={() => setTeamId(t.id)}
                    className={`secretary-choice ui-button-secondary p-4 ${team?.id === t.id ? 'ring-2 ring-blue-500' : ''}`}>
                    <Building2 size={20} /> {t.name}
                </button>)}
            </div>
            {team && <>
                <h2 className="text-xl text-slate-100 mb-4">Secretarias atendidas por {team.name}</h2>
                {!team.secretaries.length && <p className="text-slate-400">Nenhuma secretaria vinculada a esta equipe.</p>}
                <div className="grid gap-3 md:grid-cols-2">
                    {team.secretaries.map(s => <button key={s.id} onClick={() => select(s)} className="secretary-choice ui-button-secondary p-4 text-left">
                        {s.name} <ArrowRight size={18} />
                    </button>)}
                </div>
            </>}
            <button onClick={logout} className="secretary-choice ui-button-secondary mt-6"><LogOut size={16} /> Sair</button>
        </div>
    </div>;
}
